import { Component } from '@angular/core';
import { UIRouterGlobals, UIRouterModule } from '@uirouter/angular';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { CompanyAccessService } from '../../services/company-access.service';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'settings-tabs',
  templateUrl: './settings-tabs.component.html',
  styleUrls: ['./settings-tabs.component.scss'],
  imports: [
    CommonModule,
    MatTabsModule,
    MatIconModule,
    UIRouterModule
  ]
})
export class SettingsTabsComponent {

  constructor(
    private uiRouterGlobals: UIRouterGlobals,
    private userStateService: UserStateService,
    private companyAccessService: CompanyAccessService,
    private featuresService: FeaturesService
  ) { }

  links = [
    {
      name: 'Company Settings',
      route: 'apps.settings.company-details',
      id: 'company-details',
      shown: () => this.userStateService.isRiseAdmin() || this.userStateService.isUserAdmin()
    },
    {
      name: 'Company Users',
      route: 'apps.settings.user-list',
      id: 'user-list',
      shown: () => this.userStateService.isRiseAdmin() || this.userStateService.isUserAdmin()
    },
    {
      name: 'SSO Settings',
      route: 'apps.settings.sso-settings',
      id: 'sso-settings',
      shown: () => this.userStateService.isRiseAdmin() || this.userStateService.isUserAdmin()
    },
    {
      name: 'Companies & Licenses',
      route: 'apps.settings.company-licenses',
      id: 'company-licenses',
      shown: () => true,
      upgrade: () => !this.companyAccessService.accessCompanyLicenses
    },
    {
      name: 'Account & Billing',
      route: 'apps.settings.billing.home',
      id: 'billing-home',
      shown: () => !this.userStateService.isAssignedPublisher()
    }
  ];

  isLinkActive(route: string): boolean {
    return this.uiRouterGlobals.current?.name === route;
  }

  upgradePlan() {
    this.featuresService.showUpgradePlanModal(FeaturesService.FEATURE_LICENSE_MANAGEMENT);
  }
}
